import {Box, Grid, styled} from "@mui/material"
import React from "react"
import {getMerkmal} from "../../misc/widget-functions"

export const alertCardPrototype = [
    {
        key: "showDot",
        type: "YESNO",
        label: "Punkt anzeigen?",
        size: 3,
    },
    {
        key: "showCloseButton",
        type: "YESNO",
        label: "Schließen Button anzeigen?",
        size: 3,
    },
    {
        key: "error",
        type: "YESNO",
        label: "Error",
        size: 3,
    },
    {
        key: "action",
        type: "STRING",
        label: "Close Action",
        size: 3,
    },
    {
        key: "title",
        type: "STRING",
        label: "Title",
        size: 3,
    },
    {
        key: "subtitle",
        type: "STRING",
        label: "Subtitle",
        size: 3,
    },
    {
        key: "variant",
        type: "SELECT",
        label: "Variante",
        size: 3,
        options: [
            {
                value: "info",
                label: "Info",
            },
            {
                value: "warning",
                label: "Warning",
            },
            {
                value: "success",
                label: "Success",
            },
        ],
    },
]

const StyledAlertCard = styled(Box, {
    name: "StyledAlertCard",
    slot: "Root",
    shouldForwardProp: (prop) =>
        prop !== "error" && prop !== "disabled" && prop !== "variant",
})(() => ({}))

const StyledAlertCardTitle = styled(Box, {
    name: "AlertCardTitle",
    slot: "Root",
    shouldForwardProp: (prop) =>
        prop !== "error" && prop !== "disabled" && prop !== "variant",
})(() => ({}))

const StyledAlertCardSubtitle = styled(Box, {
    name: "AlertCardSubtitle",
    slot: "Root",
    shouldForwardProp: (prop) =>
        prop !== "error" && prop !== "disabled" && prop !== "variant",
})(() => ({}))

const Dot = styled("div")({
    width: "16px",
    height: "16px",
    borderRadius: "16px",
})

const AlertCard = ({widget, disabled, error, getDataFromPointer}) => {
    const {title, subtitle, variant = "info", showDot, showCloseButton} = widget
    const cardDisabled = widget?.disabled || disabled
    const cardError = widget?.error || error
    const pointer = getMerkmal(widget)?.pointer
    const evaluatedText = getDataFromPointer(pointer) ?? subtitle

    const sharedProps = {
        variant: variant,
        error: cardError,
        disabled: cardDisabled,
    }

    return (
        <StyledAlertCard {...sharedProps}>
            <Grid
                container
                spacing={0.5}
                sx={{display: "flex", flexWrap: "nowrap"}}>
                {showDot && (
                    <Grid>
                        <Dot
                            className="AlertCardDot"
                            {...sharedProps}
                        />
                    </Grid>
                )}
                <Grid
                    container
                    sx={{display: "flex", flexGrow: 1, flexDirection: "column"}}
                    spacing={1}>
                    {title && (
                        <Grid>
                            <StyledAlertCardTitle {...sharedProps}>
                                {title}
                            </StyledAlertCardTitle>
                        </Grid>
                    )}
                    {evaluatedText && (
                        <Grid>
                            <StyledAlertCardSubtitle {...sharedProps}>
                                {evaluatedText}
                            </StyledAlertCardSubtitle>
                        </Grid>
                    )}
                </Grid>
                {showCloseButton && <Grid>Close Button</Grid>}
            </Grid>
        </StyledAlertCard>
    )
}

export default AlertCard
